(function ManagerCustomerSearchForm($, HE)
{
	"use strict";

	var form = {
		name: 'CustomerSearch',
	};

	$(document).ready(function documentReady()
	{
		HE.Form.registerForm(form);
	});

	form.load = function load($form)
	{
		var $agent_ids = $('#customersearch-agent_id');

		$('#customersearch-client_id').on('change', function loadAgents()
		{
			var opts = [];

			HE.Ajax.get('/Clients/getAgentsForClient/' + this.value)
			.then(function _processAgentIds(data)
			{
				$agent_ids.empty();

				opts = [
					'<option>All Agents</option>',
				];

				data.forEach(function _populateAgentIds(agent) {
					opts.push('<option value="' + agent.id + '">' + agent.name + '</option>');
				});

				$agent_ids.append(opts);
			});
		});
	};
}(jQuery, window.HE || {}));